export default __webpack_public_path__ + "static/media/NIAS0170.34I-32776_-24645_0.e4a3b4f0.jpg";